import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '@/modules/general-notes/styles.less';
import Note from '@/modules/general-notes/components/Note';

const Notes = ({
  list = [],
  loading,
  showEmptyState,
  onSaveNote,
  onDeleteNote,
  onToggleItem,
}) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className={styles.noList}>
        <span>{t('Loading...')}</span>
      </div>
    );
  }

  if (showEmptyState) {
    return (
      <div className={styles.noList}>
        <span>
          {t(
            'Use "General Notes" to create and track personal notes, comments, and/or reminders.\nClick "New Note" to get started with your first note.'
          )}
        </span>
      </div>
    );
  }

  return (
    <>
      {list.map((note) => (
        <Note
          key={note.id}
          {...note}
          onSave={onSaveNote}
          onDelete={onDeleteNote}
          onToggleItem={onToggleItem}
        />
      ))}
    </>
  );
};

export default Notes;
